<template>
  <form
    ref="form"
    data-url="/annexes/local"
    class="mb-0 mt-4"
    :class="{ 'loading-opacity': preloader }"
  >
    <fieldset class="form-group">
      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>ANEXO 4. LOCALES Y CONDICIONES AMBIENTALES / SEGURIDAD</h5>
        </legend>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label>NÚMERO DE AMBIENTES PARA LOS ENSAYOS</label>
            <app-input
              type="number"
              v-model="inputs.environments_no"
              :required="true"
              placeholder="Ingrese la cantidad de ambientes para ensayos"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label>ÁREA TOTAL DE TRABAJO (M²)</label>
            <app-input
              type="number"
              v-model="inputs.total_area"
              :required="true"
              placeholder="Ingrese el area total de trabajo"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Seguridades en el trabajo</label>
            <app-input
              type="select"
              v-model="inputs.security"
              :required="true"
              :list="listOptions"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Iluminación</label>
            <app-input
              type="select"
              v-model="inputs.illumination"
              :required="true"
              :list="listOptions"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Temperatura</label>
            <app-input
              type="select"
              v-model="inputs.temperature"
              :required="true"
              :list="listOptions"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Humedad</label>
            <app-input
              type="select"
              v-model="inputs.humidity"
              :required="true"
              :list="listOptions"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Ventilación</label>
            <app-input
              type="select"
              v-model="inputs.ventilation"
              :required="true"
              :list="listOptions"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Otros</label>
            <app-input
              type="textarea"
              v-model="inputs.others"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 mt-3" v-if="!disabled">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "#/Accreditation/Resources/assets/js/apiUrl";
export default {
  mixins: [FormMixin],
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      listOptions: [
        { id: "", value: this.$t("select_option") },
        { id: "SI", value: "SI" },
        { id: "NO", value: "NO" },
        { id: "NA", value: "NA" },
      ],
    };
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.inputs.accreditation_application_id = this.$store.state.accreditation.id;
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `${actions.ANNEXES_LOCAL}/${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs = response.data ? response.data : {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
